export const UPLOAD_STATUS = {
  // Waiting for upload
  INITIALIZING: 'INITIALIZING',

  // Upload to oss
  UPLOADING: 'UPLOADING',
  UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
  UPLOAD_FAILED: 'UPLOAD_FAILED',
  CANCEL_UPLOAD: 'CANCEL_UPLOAD',
  CANCEL_UPLOAD_SUCCESS: 'CANCEL_UPLOAD_SUCCESS',
  CANCEL_UPLOAD_FAILED: 'CANCEL_UPLOAD_FAILED',

  // For upload command
  PROCESSING: 'PROCESSING',
  PROCESS_FAILED: 'PROCESS_FAILED',
};

export const FOLDER_LIMIT = 200;

export const DOCUMENT_LIMIT = 50;
